const mapCategoryToSchema = category => {
  switch (category) {
    case 'airconditioning':
    case 'central heating':
      return 'HVAC';

    case 'alarms / security':
    case 'garage / vehicle services':
    case 'hire services':
    case 'it and consultancy':
    case 'metalwork / blacksmith':
    case 'miscellaneous services':
    case 'mobility':
    case 'motor homes':
    case 'oven cleaning':
    case 'pest / vermin control':
    case 'renewable energy':
    case 'rubbish / waste / clearance':
    case 'scaffolder':
    case 'shop fitting':
    case 'stonemason':
    case 'surveying':
    case 'telecommunications':
    case 'towing / transportation':
    case 'transport services':
      return 'LocalBusiness';

    case 'bathrooms':
    case 'plumber':
      return 'Plumber';

    case 'electrician':
      return 'Electrician';

    case 'handyman':
      return 'GeneralContractor';

    case 'locksmith':
      return 'Locksmith';

    case 'removals / storage':
      return 'MovingCompany';

    case 'roofer':
      return 'RoofingContractor';

    default:
      return 'HomeAndConstructionBusiness';
  }
};

export default mapCategoryToSchema;
